import { render, staticRenderFns } from "./PAvailableUptimeSelector.vue?vue&type=template&id=6b07c118&scoped=true&"
import script from "./PAvailableUptimeSelector.vue?vue&type=script&lang=ts&"
export * from "./PAvailableUptimeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./PAvailableUptimeSelector.vue?vue&type=style&index=0&id=6b07c118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b07c118",
  null
  
)

export default component.exports